import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://932a2bed49c2479dbc3191603206d8dc@o451717.ingest.sentry.io/5538656',
});
